export const CLIENT_PRODUCT_DATA = "client_product_data"
export const CLIENT_SALES_CONTRACTOR_ORDER_DATA = "client_sales_contractor_order_data"
export const CLIENT_SALES_CONTRACTOR_PRODUCT_ID = "client_sales_contractor_order_id"
